<button class="zui-button button-comp" [disabled]="disabled" [ngClass]="{'full-width': fullWidth, 'floating': floating, 'big': big, 'flat': flat}">
  <ng-content></ng-content>
  <span class="icon" [ngClass]="prefixIcon" *ngIf="prefixIcon"></span>{{floating ? '' : label}}
</button>
